/**
 * <ReportHero> — the top section of the live-report page (molecule, L0.1).
 *
 * Mirrors the legacy `LiveReportComponent` header: the session date, the student name, the Zoé mascot,
 * and — for trial / absent reports — a `heroMessage` and the "rdv conseiller" (Sam) CTA. NOT a card:
 * it's the top block the `LiveReportDetailsTemplate` renders above the section cards. DS-pure — composes
 * `<Mascot>` + `<Button>` + `<Title>` / `<Text>` (no legacy `ChampionImageM` / `FilledButtonM`).
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Title } from "../../atoms/typography/Title"
import { Text } from "../../atoms/typography/Text"
import { Mascot } from "../../atoms/Mascot"
import { Button } from "../../atoms/Buttons/Button"
import { formatDayTime } from "../../../ports/primary/ui/formatters/dateFormatter"

export type ReportHeroProps = {
    /** ISO datetime → « Mardi 7 juillet · 10h30 », l'heure comme l'espace parent l'écrit. */
    date: string
    studentDisplayName: string
    /** Zoé mascot variant (`main` / `happy` / `unhappy`). */
    zoeVariant?: string
    /** Zoé CTA copy, or the "Malheureusement… absent" message. */
    heroMessage?: string
    /** Show the "Je prends rdv avec mon conseiller" (Sam) CTA. */
    showSamCalendlyCta?: boolean
    onSamPress?: () => void
    testID?: string
}

export function ReportHero(props: ReportHeroProps) {
    const { date, studentDisplayName, zoeVariant, heroMessage, showSamCalendlyCta, onSamPress, testID } = props

    return (
        <Stack gap="3" align="center" testID={testID}>
            <Title>{formatDayTime(date)}</Title>
            <Text>{studentDisplayName}</Text>
            <Mascot name="zoe" variant={zoeVariant} size={167} />
            {heroMessage != null && heroMessage !== "" && (
                <Text size="text-xl" weight="bold" color="primary" center>
                    {heroMessage}
                </Text>
            )}
            {showSamCalendlyCta === true && (
                <Button label="Je prends rdv avec mon conseiller" color="success" fullWidth onPress={onSamPress} />
            )}
        </Stack>
    )
}
